import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
}

* {
  box-sizing: border-box;
}

.mahjong-page {
  --ink: #17201d;
  --muted: #65706b;
  --paper: #f4f1e9;
  --surface: #fffdf8;
  --line: #ddd8cc;
  --indigo: #243c5a;
  --green: #176556;
  --coral: #d96952;
  min-height: 100%;
  color: var(--ink);
  background: radial-gradient(circle at 12% 0%, rgba(36, 60, 90, 0.08), transparent 30rem), linear-gradient(180deg, #f8f6f0 0%, var(--paper) 100%);
}

.topbar {
  position: sticky;
  z-index: 20;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
  padding: 0 42px;
  border-bottom: 1px solid rgba(23, 32, 29, 0.12);
  background: rgba(248, 246, 240, 0.92);
  backdrop-filter: blur(16px);
}

.brand-lockup,
.brand-copy,
.model-pill,
.hero-badges,
.hand-actions,
.best-main,
.rank-title,
.rank-meta,
.page-footer {
  display: flex;
  align-items: center;
}

.brand-lockup {
  gap: 12px;
}

.brand-mark {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 8px;
  background: var(--indigo);
  color: white;
  font-family: serif;
  font-size: 19px;
}

.brand-copy {
  align-items: flex-start;
  flex-direction: column;
  line-height: 1.1;
}

.brand-copy strong {
  font-size: 13px;
  letter-spacing: 0.12em;
}

.brand-copy span {
  margin-top: 5px;
  color: var(--muted);
  font-size: 10px;
  letter-spacing: 0.08em;
}

.model-pill {
  gap: 8px;
  padding: 7px 11px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.58);
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #9a9f9c;
}

.model-pill.is-ready .status-dot {
  background: #2f9f75;
  box-shadow: 0 0 0 4px rgba(47, 159, 117, 0.13);
}

.page-scroll {
  padding: 0 42px 32px;
}

.hero {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(360px, 0.8fr);
  gap: 80px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 58px 0 44px;
}

.eyebrow,
.section-kicker {
  margin: 0;
  color: var(--coral);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.17em;
}

.hero h1 {
  max-width: 720px;
  margin: 13px 0 16px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(34px, 4vw, 57px);
  font-weight: 500;
  line-height: 1.12;
  letter-spacing: -0.045em;
}

.hero-description {
  max-width: 760px;
  margin: 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.75;
}

.hero-badges {
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 24px;
}

.hero-badges span {
  padding: 6px 9px;
  border: 1px solid var(--line);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.45);
  color: #4d5853;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.hero-metrics {
  display: grid;
  align-self: end;
  grid-template-columns: repeat(4, 1fr);
  padding: 22px 0;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.hero-metric {
  padding: 0 20px;
  border-left: 1px solid var(--line);
}

.hero-metric:first-child {
  padding-left: 0;
  border-left: 0;
}

.hero-metric span {
  display: block;
  margin-bottom: 8px;
  color: var(--muted);
  font-size: 10px;
}

.hero-metric strong {
  font-family: Georgia, serif;
  font-size: 25px;
  font-weight: 500;
}

.workspace-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(390px, 0.75fr);
  gap: 18px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}

.panel {
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: rgba(255, 253, 248, 0.92);
  box-shadow: 0 18px 60px rgba(29, 42, 36, 0.06);
}

.input-panel {
  padding: 28px;
}

.result-panel {
  min-height: 680px;
  padding: 28px;
  background: #fdfbf6;
}

.panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 23px;
}

.panel-heading h2 {
  margin: 6px 0 0;
  font-size: 20px;
  letter-spacing: -0.03em;
}

.hand-counter {
  color: var(--muted);
  font-size: 12px;
}

.hand-counter strong {
  margin-right: 4px;
  color: var(--coral);
  font-family: Georgia, serif;
  font-size: 25px;
}

.hand-counter.is-complete strong {
  color: var(--green);
}

.current-hand {
  display: flex;
  align-items: flex-end;
  min-height: 104px;
  padding: 17px;
  overflow-x: auto;
  border-radius: 10px;
  background: linear-gradient(145deg, #174d43, #0f3c35);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.hand-empty {
  margin: auto;
  color: rgba(255, 255, 255, 0.58);
  font-size: 12px;
}

.hand-tile,
.palette-tile,
.result-tile,
.rank-tile {
  color: #17201d;
  background: linear-gradient(145deg, #fffef9, #eee9dd);
  box-shadow: 0 3px 0 #c9c2b4, 0 7px 12px rgba(0, 0, 0, 0.15);
}

.hand-tile {
  flex: 0 0 48px;
  height: 68px;
  margin-right: 5px;
  border: 0;
  border-radius: 5px;
  transition: transform 120ms ease;
}

.hand-tile:hover {
  transform: translateY(-7px);
}

.tile-face {
  display: block;
  font-size: 17px;
  font-weight: 800;
}

.hand-tile small {
  display: block;
  margin-top: 7px;
  color: #8a8c87;
  font-size: 9px;
}

[data-tone=man] .tile-face, .result-tile[data-tone=man], .rank-tile[data-tone=man] {
  color: #b74739;
}

[data-tone=pin] .tile-face, .result-tile[data-tone=pin], .rank-tile[data-tone=pin] {
  color: #315f9f;
}

[data-tone=sou] .tile-face, .result-tile[data-tone=sou], .rank-tile[data-tone=sou] {
  color: #247457;
}

[data-tone=honor] .tile-face, .result-tile[data-tone=honor], .rank-tile[data-tone=honor] {
  color: #2b312e;
}

.draw-slot {
  display: grid;
  flex: 0 0 48px;
  height: 68px;
  margin-left: 8px;
  place-items: center;
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  color: rgba(255, 255, 255, 0.55);
}

.hand-actions {
  justify-content: flex-end;
  gap: 16px;
  margin-top: 12px;
}

.text-button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--muted);
  font-size: 11px;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.tile-palette {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--line);
}

.tile-group {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.group-label {
  padding-top: 13px;
  color: var(--muted);
  font-size: 10px;
  font-weight: 700;
}

.tile-row {
  display: grid;
  grid-template-columns: repeat(9, minmax(40px, 1fr));
  gap: 6px;
}

.palette-tile {
  min-width: 0;
  height: 50px;
  border: 1px solid #d8d2c6;
  border-radius: 5px;
  box-shadow: 0 2px 0 #d1cabc;
  font-size: 12px;
  font-weight: 800;
}

.palette-tile small {
  display: block;
  margin-top: 3px;
  color: #9a9b96;
  font-size: 8px;
  font-weight: 500;
}

.palette-tile:disabled {
  cursor: not-allowed;
  opacity: 0.35;
  box-shadow: none;
}

.palette-tile:not(:disabled):hover {
  border-color: var(--green);
  transform: translateY(-1px);
}

.context-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 24px;
}

.context-field span {
  display: block;
  margin-bottom: 7px;
  color: var(--muted);
  font-size: 10px;
  font-weight: 700;
}

.context-field select,
.context-field input {
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border: 1px solid var(--line);
  border-radius: 6px;
  outline: none;
  background: #fff;
  color: var(--ink);
  font-size: 12px;
}

.context-field select:focus, .context-field input:focus {
  border-color: var(--green);
  box-shadow: 0 0 0 3px rgba(23, 101, 86, 0.09);
}

.discard-context {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--line);
}

.discard-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.discard-heading h3 {
  margin: 6px 0 0;
  font-size: 15px;
  letter-spacing: -0.02em;
}

.discard-description {
  margin: 9px 0 13px;
  color: var(--muted);
  font-size: 10px;
  line-height: 1.55;
}

.discard-rows {
  display: grid;
  gap: 8px;
}

.discard-row {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 174px;
  gap: 10px;
  align-items: center;
  min-height: 48px;
  padding: 8px 10px;
  border: 1px solid #e5e0d6;
  border-radius: 7px;
  background: #fbfaf6;
}

.discard-row.is-self {
  border-color: rgba(23, 101, 86, 0.4);
  background: #f3f9f6;
}

.player-name {
  display: flex;
  align-items: center;
  gap: 6px;
}

.player-name strong {
  font-size: 11px;
}

.player-name span {
  padding: 2px 5px;
  border-radius: 999px;
  background: var(--green);
  color: white;
  font-size: 8px;
  font-weight: 800;
}

.player-name small {
  color: var(--muted);
  font-size: 9px;
}

.riichi-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 7px;
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
}

.riichi-toggle input {
  width: 12px;
  height: 12px;
  accent-color: var(--coral);
}

.discard-tiles {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  min-height: 30px;
  overflow-x: auto;
}

.discard-empty {
  color: #9a9e99;
  font-size: 9px;
}

.discard-tile {
  flex: 0 0 25px;
  height: 31px;
  padding: 0;
  border: 1px solid #d8d2c6;
  border-radius: 4px;
  background: linear-gradient(145deg, #fffef9, #eee9dd);
  box-shadow: 0 1px 0 #d1cabc;
  font-size: 9px;
  font-weight: 800;
}

.discard-controls {
  display: flex;
  gap: 6px;
}

.discard-controls select {
  min-width: 0;
  flex: 1;
  height: 30px;
  padding: 0 6px;
  border: 1px solid var(--line);
  border-radius: 5px;
  background: white;
  color: var(--ink);
  font-size: 10px;
}

.add-discard-button {
  height: 30px;
  padding: 0 10px;
  border: 0;
  border-radius: 5px;
  background: #e9e5da;
  color: var(--indigo);
  font-size: 10px;
  font-weight: 800;
}

.add-discard-button:not(:disabled):hover {
  background: var(--indigo);
  color: white;
}

.add-discard-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.table-summary {
  display: flex;
  gap: 7px;
  margin-top: 16px;
}

.table-summary span {
  padding: 5px 7px;
  border: 1px solid rgba(23, 101, 86, 0.22);
  border-radius: 4px;
  background: #eff7f3;
  color: #35675a;
  font-size: 9px;
  font-weight: 700;
}

.error-message {
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 6px;
  background: #fff0ec;
  color: #a44332;
  font-size: 11px;
}

.analyze-button {
  width: 100%;
  height: 48px;
  margin-top: 18px;
  border: 0;
  border-radius: 7px;
  background: var(--indigo);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.analyze-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(36, 60, 90, 0.22);
}

.analyze-button:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}

.result-count {
  color: var(--muted);
  font-size: 10px;
}

.result-placeholder, .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 530px;
  flex-direction: column;
  text-align: center;
}

.placeholder-orbit {
  display: grid;
  width: 88px;
  height: 88px;
  margin-bottom: 22px;
  place-items: center;
  border: 1px solid var(--line);
  border-radius: 50%;
  background: radial-gradient(circle, white 40%, #f1ede3 41%);
  color: var(--indigo);
  font-family: serif;
  font-size: 28px;
}

.result-placeholder h3, .loading-state h3 {
  margin: 0 0 8px;
  font-size: 15px;
}

.result-placeholder p, .loading-state p {
  max-width: 280px;
  margin: 0;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.6;
}

.loader-ring {
  width: 46px;
  height: 46px;
  margin-bottom: 24px;
  border: 3px solid #e1ddd3;
  border-top-color: var(--coral);
  border-radius: 50%;
  animation: spin 800ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.best-card {
  padding: 20px;
  border-radius: 10px;
  background: var(--indigo);
  color: white;
}

.best-rank {
  margin-bottom: 16px;
  color: #b9c9da;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.best-main {
  align-items: center;
}

.result-tile {
  display: grid;
  flex: 0 0 66px;
  height: 82px;
  place-items: center;
  border-radius: 6px;
}

.result-tile strong {
  font-size: 22px;
}

.result-tile small {
  margin-top: -23px;
  color: #8c8e89;
  font-size: 9px;
}

.best-copy {
  margin-left: 17px;
}

.best-copy h3 {
  margin: 0 0 10px;
  font-size: 18px;
}

.best-copy p {
  margin: 0 0 3px;
  color: #b9c9da;
  font-size: 10px;
}

.best-copy strong {
  font-family: Georgia, serif;
  font-size: 31px;
  font-weight: 500;
}

.best-copy span {
  margin-left: 3px;
  color: #b9c9da;
  font-size: 10px;
}

.best-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.best-stat {
  padding-left: 14px;
  border-left: 1px solid rgba(255, 255, 255, 0.13);
}

.best-stat:first-child {
  padding-left: 0;
  border-left: 0;
}

.best-stat span {
  display: block;
  margin-bottom: 5px;
  color: #b9c9da;
  font-size: 9px;
}

.best-stat strong {
  font-size: 13px;
}

.ranking-list {
  margin-top: 18px;
}

.rank-row {
  display: grid;
  grid-template-columns: 28px 40px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e5e0d6;
}

.rank-number {
  color: #9b9e99;
  font-family: Georgia, serif;
  font-size: 12px;
}

.rank-tile {
  display: grid;
  width: 36px;
  height: 45px;
  place-items: center;
  border-radius: 4px;
  box-shadow: 0 2px 0 #d1cabc;
  font-size: 11px;
  font-weight: 800;
}

.rank-detail {
  min-width: 0;
}

.rank-title {
  justify-content: space-between;
}

.rank-title strong {
  font-size: 11px;
}

.rank-title span {
  color: var(--green);
  font-size: 11px;
  font-weight: 800;
}

.score-track {
  height: 3px;
  margin: 7px 0;
  overflow: hidden;
  border-radius: 2px;
  background: #ebe7de;
}

.score-fill {
  height: 100%;
  border-radius: 2px;
  background: var(--coral);
}

.rank-meta {
  gap: 10px;
  color: #848b86;
  font-size: 8px;
}

.model-note {
  margin-top: 18px;
  padding: 13px 14px;
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #f7f4ed;
}

.model-note strong {
  font-size: 10px;
}

.model-note p {
  margin: 5px 0 0;
  color: var(--muted);
  font-size: 9px;
  line-height: 1.5;
}

.gain-note {
  border-color: rgba(23, 101, 86, 0.28);
  background: #eff7f3;
}

.page-footer {
  justify-content: space-between;
  width: 100%;
  max-width: 1440px;
  margin: 28px auto 0;
  color: #8b918d;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

@media (max-width: 1080px) {
  .hero {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  .hero-metrics {
    max-width: 560px;
  }
  .workspace-grid {
    grid-template-columns: 1fr;
  }
  .result-panel {
    min-height: auto;
  }
  .result-placeholder, .loading-state {
    min-height: 360px;
  }
}
@media (max-width: 720px) {
  .topbar {
    height: 60px;
    padding: 0 16px;
  }
  .brand-copy span {
    display: none;
  }
  .page-scroll {
    padding: 0 12px 24px;
  }
  .hero {
    padding: 38px 4px 28px;
  }
  .hero h1 {
    font-size: 36px;
  }
  .hero-metrics {
    grid-template-columns: repeat(3, 1fr);
  }
  .hero-metric {
    padding: 0 10px;
  }
  .hero-metric strong {
    font-size: 18px;
  }
  .input-panel, .result-panel {
    padding: 18px;
  }
  .hand-tile {
    flex-basis: 41px;
    height: 60px;
  }
  .tile-row {
    grid-template-columns: repeat(5, 1fr);
  }
  .context-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .discard-row {
    grid-template-columns: 88px minmax(0, 1fr);
  }
  .discard-controls {
    grid-column: 1/-1;
  }
  .page-footer {
    align-items: flex-start;
    gap: 8px;
    flex-direction: column;
  }
}`],
})
export class PageHomeComponent implements OnInit {
    public tileGroups: any[] = [];
    public discardTiles: any[] = [];
    public hand: number[] = [0, 1, 2, 3, 4, 6, 7, 10, 11, 12, 23, 24, 27, 27];
    public discards: number[][] = [[], [], [], []];
    public riichiPlayers: boolean[] = [false, false, false, false];
    public discardSelections: number[] = [0, 0, 0, 0];
    public openMelds: number = 0;
    public seat: number = 0;
    public roundWind: number = 0;
    public turn: number = 6;
    public score: number = 25000;
    public loading: boolean = false;
    public error: string = '';
    public modelStatus: any = null;
    public analysis: any = null;

    private labels: string[] = [
        '1만', '2만', '3만', '4만', '5만', '6만', '7만', '8만', '9만',
        '1통', '2통', '3통', '4통', '5통', '6통', '7통', '8통', '9통',
        '1삭', '2삭', '3삭', '4삭', '5삭', '6삭', '7삭', '8삭', '9삭',
        '동', '남', '서', '북', '백', '발', '중'
    ];
    private codes: string[] = [
        '1m', '2m', '3m', '4m', '5m', '6m', '7m', '8m', '9m',
        '1p', '2p', '3p', '4p', '5p', '6p', '7p', '8p', '9p',
        '1s', '2s', '3s', '4s', '5s', '6s', '7s', '8s', '9s',
        'E', 'S', 'W', 'N', 'P', 'F', 'C'
    ];
    private seatLabels: string[] = ['동가', '남가', '서가', '북가'];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.tileGroups = [
            { label: '만수', tone: 'man', tiles: this.makeTiles(0, 9) },
            { label: '통수', tone: 'pin', tiles: this.makeTiles(9, 18) },
            { label: '삭수', tone: 'sou', tiles: this.makeTiles(18, 27) },
            { label: '자패', tone: 'honor', tiles: this.makeTiles(27, 34) }
        ];
        this.discardTiles = this.tileGroups.reduce((tiles, group) => tiles.concat(group.tiles), []);
        await this.loadStatus();
        await this.service.render();
    }

    private makeTiles(start: number, end: number) {
        const tiles: any[] = [];
        for (let index = start; index < end; index++) {
            tiles.push({ index, label: this.labels[index], code: this.codes[index] });
        }
        return tiles;
    }

    public expectedHandSize() {
        return 14 - (Number(this.openMelds) * 3);
    }

    public countTile(index: number) {
        return this.hand.filter((value) => value === index).length;
    }

    public publicTileCount(index: number) {
        return this.discards.reduce(
            (total, row) => total + row.filter((value) => value === index).length,
            this.countTile(index)
        );
    }

    public discardCount(player: number) {
        return this.discards[player].length;
    }

    public totalDiscardCount() {
        return this.discards.reduce((total, row) => total + row.length, 0);
    }

    public tileTone(index: number) {
        if (index < 9) return 'man';
        if (index < 18) return 'pin';
        if (index < 27) return 'sou';
        return 'honor';
    }

    public tileLabel(index: number) {
        return this.labels[index] || '';
    }

    public tileCode(index: number) {
        return this.codes[index] || '';
    }

    public seatLabel(player: number) {
        return this.seatLabels[player] || '';
    }

    public isSelf(player: number) {
        return Number(player) === Number(this.seat);
    }

    public async addTile(index: number) {
        if (this.hand.length >= this.expectedHandSize() || this.publicTileCount(index) >= 4) return;
        this.hand.push(index);
        this.hand.sort((left, right) => left - right);
        await this.resetAnalysis();
    }

    public async removeTile(position: number) {
        this.hand.splice(position, 1);
        await this.resetAnalysis();
    }

    public async clearHand() {
        this.hand = [];
        await this.resetAnalysis();
    }

    public async addDiscard(player: number) {
        const index = Number(this.discardSelections[player]);
        if (this.publicTileCount(index) >= 4) return;
        this.discards[player].push(index);
        this.discards[player].sort((left, right) => left - right);
        await this.resetAnalysis();
    }

    public async removeDiscard(player: number, position: number) {
        this.discards[player].splice(position, 1);
        await this.resetAnalysis();
    }

    public async clearDiscards() {
        this.discards = [[], [], [], []];
        this.riichiPlayers = [false, false, false, false];
        await this.resetAnalysis();
    }

    public async loadSample() {
        this.openMelds = 0;
        this.hand = [0, 1, 2, 3, 4, 6, 7, 10, 11, 12, 23, 24, 27, 27];
        this.discards = [[], [], [], []];
        this.riichiPlayers = [false, false, false, false];
        await this.resetAnalysis();
    }

    public async onMeldChange() {
        const expected = this.expectedHandSize();
        if (this.hand.length > expected) this.hand = this.hand.slice(0, expected);
        await this.resetAnalysis();
    }

    public async onTableContextChange() {
        await this.resetAnalysis();
    }

    private async resetAnalysis() {
        this.analysis = null;
        this.error = '';
        await this.service.render();
    }

    public async loadStatus() {
        const response = await wiz.call('status', {});
        if (response.code === 200) this.modelStatus = response.data;
    }

    public async analyze() {
        if (this.hand.length !== this.expectedHandSize()) {
            this.error = '현재 설정에서는 손패 ' + this.expectedHandSize() + '장이 필요합니다.';
            await this.service.render();
            return;
        }
        this.loading = true;
        this.error = '';
        this.analysis = null;
        await this.service.render();
        const response = await wiz.call('recommend', {
            hand: JSON.stringify(this.hand),
            discards: JSON.stringify(this.discards),
            riichi_players: JSON.stringify(this.riichiPlayers),
            open_melds: Number(this.openMelds),
            seat: Number(this.seat),
            round_wind: Number(this.roundWind),
            turn: Number(this.turn),
            score: Number(this.score)
        });
        this.loading = false;
        if (response.code === 200) {
            this.analysis = response.data;
        } else {
            this.error = response.data && response.data.message
                ? response.data.message
                : '버림패 분석에 실패했습니다.';
        }
        await this.service.render();
    }
}

export default PageHomeComponent;